import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';

import { menusSlice } from '../_menus.slice';
import {
  FontAwesomeIconStyled,
  ListItemIconStyled,
  RootListItemButtonStyled,
} from '../Menu.styles';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
  isMenuOpened,
} from '../menus.selectors';

export const DashboardMenuItem = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const isOpen = useSelector(isMenuOpened);

  const { isAbleToProceed } = useIsAbleToProceed();

  const OPTION_ID = 'DASHBOARD';
  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      dispatch(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
      );
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
      dispatch(marketStockExchangeSlice.actions.setSelectedTitle({}));
    });
  };
  return (
    <RootListItemButtonStyled
      id="btnMenuDashboard"
      onClick={(event) => handleClickLeafMenu(event, OPTION_ID)}
      component={NavLink}
      to="/Dashboard"
      selected={activeMenuItem?.includes(OPTION_ID)}
      isActiveNavigationMenuItemEmpty={activeNavigationMenuItem === ''}
      isOpen={isOpen}
    >
      <ListItemIconStyled>
        <FontAwesomeIconStyled
          icon={faDesktop}
          selected={activeMenuItem?.includes(OPTION_ID)}
        />
      </ListItemIconStyled>
      <ListItemText primary={<FormattedMessage id="TRLT_UI-DASHBOARD" />} />
    </RootListItemButtonStyled>
  );
};

DashboardMenuItem.propTypes = {
  isOpen: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  activeNavigationMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  setActiveNavigationMenuItem: PropTypes.func,
  setSelectedTitle: PropTypes.func,
};
